import { Component, EventEmitter, Input, Output } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { BillingAddress, BusinessModel, MARKETPLACE_MATOMO_EVENT_CATEGORY_BILLING, MarketplaceBillingInformationState } from '@platform-frontend/marketplace';
import { MobileService } from '@platform-frontend/ui-tools';
import { Observable } from 'rxjs';
import { CHECKOUT_TRANSLOCO_SCOPE } from '../../checkout-transloco-scope';
import { ProductState } from '../../product';

@Component({
  selector: 'yat-no-billing-address-selected-panel',
  templateUrl: './no-billing-address-selected-panel.component.html',
  styleUrls: ['./no-billing-address-selected-panel.component.scss'],
  providers: [provideTranslocoScope(CHECKOUT_TRANSLOCO_SCOPE)]
})
export class NoBillingAddressSelectedPanelComponent {
  constructor(private mobileService: MobileService, private store: Store) {}

  @Input()
  billingAddressRequired: boolean | null = false;

  @Output()
  createFirstAddress: EventEmitter<void> = new EventEmitter();

  @Output()
  selectExistingAddress: EventEmitter<void> = new EventEmitter();

  readonly MATOMO_EVENT_CATEGORY_BILLING = MARKETPLACE_MATOMO_EVENT_CATEGORY_BILLING;
  billingAddresses$: Observable<BillingAddress[]> = this.store.select(MarketplaceBillingInformationState.billingAddresses);
  businessModel$: Observable<BusinessModel | null> = this.store.select(ProductState.businessModel);

  select(createFirst: boolean): void {
    if (createFirst) {
      this.createFirstAddress.next();
    } else {
      this.selectExistingAddress.next();
    }
  }

  isMobile(): boolean {
    return this.mobileService.isMobileScreenSize();
  }
}
